import Button from 'components/atoms/students/Button';
import ModalTextContainer from 'components/molecules/students/ModalTextContainer';
import React from 'react';
import styled from '@emotion/styled';
export default (props) => {
    const message = props.message || 'Something is wrong...';
    return (React.createElement(Container, null,
        React.createElement(ModalTextContainer, { heading: 'ERROR', text: message, isError: true }),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { type: "blue", onClick: () => window.location.reload() }, "Try Again"))));
};
const Container = styled.div `
  width: 100%;
  height: 100%;
`;
const ButtonContainer = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
`;
